export default {"src":"/_next/static/media/0x056fd409e1d7a124bd7017459dfea2f387b6d5cd.61c4756a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};